// @ts-nocheck
import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AssetListNEW from "../components/AssetListNEW";
import { AssetBreadCrumb } from "../components/AssetBreadCrumb";
import AssetDescription from "../components/AssetDescription";
import AssetGraph from "../components/AssetGraphComponents/AssetGraph";
import { useParams } from "react-router-dom";
import LoadingIcon from "../components/LoadingIcon";
import { fetchAssetGroupById } from "../store/assetGroupSlice";
import { fetchAssetsByGroupId, fetchGroupsAndNestedAssets } from "../store/assetsSlice";
import { generateClient } from "aws-amplify/api";
import { getUser } from "../graphql/queries";
import ExploreDashboard from "../components/ExplorePage/ExploreDashboard";

const ExplorePage = () => {
  const dispatch = useDispatch();
  const [assetOwner, setAssetOwner] = useState(null);
  const { assets, assetGroups, user } = useSelector(
    ({ assets, assetGroups, user }) => ({
      assets,
      assetGroups,
      user,
    })
  );

  const fetchGroupsAndAssets = async () => {
    console.log("Fetching all asset groups and assets...");
    await dispatch(fetchGroupsAndNestedAssets());
    
    // After fetching, check if we have the processedModels in the assets
    const flattenedAssets = Object.values(assets.dataGroups || {}).flat();
    console.log(`Fetched ${flattenedAssets.length} assets total`);
    
    // Check for processed models
    const assetsWithModels = flattenedAssets.filter(
      asset => asset?.processedModels?.items?.length > 0
    );
    console.log(`Found ${assetsWithModels.length} assets with processed models`);
    
    // Log details of a sample asset with processed models if available
    if (assetsWithModels.length > 0) {
      const sampleAsset = assetsWithModels[0];
      console.log("Sample asset with processed models:", {
        name: sampleAsset.name,
        id: sampleAsset.id,
        processedModelsCount: sampleAsset.processedModels?.items?.length,
        modelTypes: sampleAsset.processedModels?.items?.map(model => model.modelType)
      });
      
      // Detailed inspection of the first model
      if (sampleAsset.processedModels?.items?.length > 0) {
        const firstModel = sampleAsset.processedModels.items[0];
        console.log("DETAILED INSPECTION OF FIRST MODEL:");
        console.log("Model keys:", Object.keys(firstModel));
        console.log("Model JSON:", JSON.stringify(firstModel, null, 2));
        
        // Check specifically for critical properties
        console.log("Critical properties check:");
        console.log("- id:", firstModel.id);
        console.log("- modelType:", firstModel.modelType);
        console.log("- routeShort:", firstModel.routeShort);
        console.log("- routeLong:", firstModel.routeLong);
      }
    }
  }

  useEffect(() => {
    fetchGroupsAndAssets()
  },[])
  
  return (
    <ExploreDashboard />
  );
};

export default ExplorePage;
